/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var prop = require("prop");
var xtend = require("xtend");

module.exports = Model({
	name: "workflowactions",
	init: init,
	listeners: listeners,

	recalculate: recalculate,
	refresh: refresh,

	_actions: [],
	_workflows: {},
	_manageGroups: {}
});

function init(){
	this.push([]);
	this.refresh();
}

function listeners() {
	return {
		"managegroups:updated": handleManageGroupUpdated,
		"connectivity:online": refresh,
		"workflowinstances:updated": Model.makeRecalculator("workflows"),
		"mqtt:$/workflow/actions/added": handle_action_added,
		"mqtt:$/workflow/actions/removed": handle_action_removed,
	};
}

function recalculate() {
	var workflows = this._workflows;
	var actions = this._actions;
	const manageGroups = this._manageGroups;

	const named = actions.map((action) => {
		const owners = action.owner;
		const names = owners.reduce((result, owner) => {
			const group = manageGroups[owner];
			if(!group || !group.name) return result;
			return result.concat(group.name);
		}, []);

		return {
			...action,
			ownerNames: names.join(", ")
		};
	}, []);

	var newValue = named
		.reduce(function (result, action) {
			var workflow = workflows[action.ongoingWorkflow];
			if (!workflow) return result;
			return result.concat(xtend(action, {
				ongoingWorkflow: workflow
			}));
		}, []).sort(byTime);

	if(!this.data.length && !newValue.length)
		return;

	this.push(newValue);
}

function refresh(){
	return this.api
		.workflow.actions.pending()
		.then(handle_action_list.bind(this))
		.catch(console.log.bind(console));
}

function handle_action_list(actions) {
	this._actions = actions;

	var workflowInstances = actions.map(prop("ongoingWorkflow"));

	this.emit("workflowinstances:trigger:track", {
		workflows: workflowInstances
	});
}

function handle_action_added(action){
	var ongoingWorkflow = action.ongoingWorkflow;

	this.emit("workflowinstances:trigger:track", {
		workflows: [ongoingWorkflow]
	});

	this._actions = this._actions.concat(action);

	this.emit("sounds:trigger:play", {
		sound: "alert",
		volume: 1
	});

	this.recalculate();
}

function handle_action_removed(data){
	this._actions = this._actions.filter(function(action){
		return action._id !== data._id;
	});

	this.recalculate();
}

function byTime(a, b){
	return (new Date(a.updated_at).getTime()) - (new Date(b.updated_at).getTime());
}

function handleManageGroupUpdated(groups){
	this._manageGroups = (groups || []).reduce((result, group) => {
		result[group._id] = group;
		return result;
	}, {});
	this.refresh().then(recalculate.bind(this));
}